import api from 'shared/api'

const FETCH_REQUEST = 'remunerationInformations/FETCH_REQUEST'
const FETCH_SUCCESS = 'remunerationInformations/FETCH_SUCCESS'
const FETCH_FAILURE = 'remunerationInformations/FETCH_FAILURE'
const UPLOAD_REQUEST = 'remunerationInformations/UPLOAD_REQUEST'
const UPLOAD_SUCCESS = 'remunerationInformations/UPLOAD_SUCCESS'
const UPLOAD_FAILURE = 'remunerationInformations/UPLOAD_FAILURE'

const initialState = {
  result: { data: [], total_pages: 1 },
  loaded: false,
  loading: false,
  errors: []
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function uploadRequest(payload = {}) {
  return {
    type: UPLOAD_REQUEST,
  }
}

export function uploadSuccess(payload) {
  return {
    type: UPLOAD_SUCCESS,
    payload,
  }
}

export function uploadFailure(errors = []) {
  return {
    type: UPLOAD_FAILURE,
    errors,
  }
}

export function loadRemunerationInformations(options) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(fetchRequest())
    
    return api(`api/v1/remuneration_informations`, options, {}, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))
      })
      .catch((json) => {
        dispatch(fetchFailure(json.errors))
      })
  }
}

export function uploadRemunerationInformation(options, callback) {
  const config = {
    method: 'POST',
    body: options
  }

  return (dispatch, getState) => {
    const state = getState()
    dispatch(uploadRequest())
    
    return api(`api/v1/remuneration_informations`, {}, config, false, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(uploadSuccess(json))
        callback()
      })
      .catch((json) => {
        dispatch(uploadFailure(json.errors))
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: {
          ...state.result
        },
        errors: errors
      }
    case UPLOAD_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
      })
    case UPLOAD_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: errors
      }
    default:
      return state
  }
}

